<template>
  <div style="display: flex; justify-content: center">
    <div class="MainDiv">
      <div style="margin-bottom: 1rem">
        <v-img
          src="https://www.bodytalksystem.com/images/access_banner1.jpg"
          contain
        ></v-img>
      </div>
      <div style="display: flex">
        <div
          style="
            max-width: 25%;
            padding-right: 1rem;
            border-right: 1px dashed gray;
          "
        >
          <p><b>Support</b></p>
          <p>
            Now that you have graduated from an Advanced BodyTalk Course, you
            may like to take a moment to update your Profile page if you are
            certified. <br /><br />
            We look forward to assisting you on this educational journey of
            self-awareness and wellness. If there is anything that we can help
            with please email us at
            <a href="mailto:office@bodytalksystem.com" target="_top"
              >office@bodytalksystem.com</a
            >. <br /><br />
            Sincerely,<br />
            IBA Team<br />
          </p>
          <br />

          <p><b>The Cortices Video</b></p>
          <p>
            You can share what you have learnt with your family and friends, by
            teaching them how to tap out their own cortices. We have a video
            demonstration of this technique so anyone can learn.
            <a href="https://www.youtube.com/watch?v=LqzsfszL4lc&t=75s"
              ><br />Watch now!</a
            ><br />
            <br />
          </p>

          <p><b>Expand your Knowledge</b></p>
          <p>
            Review our
            <a href="https://www.bodytalksystem.com/seminars/">
              course listings</a
            >
            to see how you can expand upon your knowledge of BodyTalk. <br />
            <br />
          </p>

          <p><b>Become a Practitioner</b></p>
          <p>
            Take BodyTalk to the next level and become a Practitioner.<br />
            <br />
          </p>
          <p><b>IBA Newsletter</b></p>
          <p>
            Stay up to date with the latest information, happenings and stories
            in the BodyTalk community.<br />
            <a
              href="http://www.bodytalksystem.com/learn/news/newsletter.cfm?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=newsletter"
              style="
                color: #003366;
                text-decoration: underline;
                font-weight: normal;
              "
              >Sign up today</a
            ><br />
          </p>
        </div>
        <div style="max-width: 75%; padding-left: 1rem">
          <h4><b>Congratulations, #createEvaluation.StudentFname#!</b></h4>
          <p>
            Congratulations on embarking on this fantastic mind-expanding
            journey of learning with IBA. We hope you enjoyed your recent
            class.<br />
            <br />
          </p>

          <p><b>Study Tips:</b></p>
          <p>
            All IBA members have access to digital versions of the Advanced
            BodyTalk Course Charts. You can find these resources in your member
            download area.<br />
            <br />
            If you have questions on any of the content presented in class, go
            on-line to the General Forum to ask. An Instructor is always
            monitoring the forum as well as many students and practitioners.
            Otherwise you may want to email your instructor directly.
            <br /><br />
            You may find it helpful to read one chapter of the course textbook
            per day. To help you process and retain the material, tap out your
            Cortices to clear your brain, and drink some water to hydrate your
            body and brain. The BodyTalk Access routine is great for supporting
            your wellbeing and is very useful as preparation for a study
            session. For even better results do the BodyTalk Access routine.
            Remember, it only takes 10 minutes.<br /><br />
          </p>

          <p><b>Feedback</b></p>
          <p>
            We understand that you may have already filled out an evaluation
            form in class. We are also aware that as you have had some time to
            process your experience, you may now have other input. This
            evaluation goes directly to the IBA. <br /><br />
            It is important for us to gain your feedback so please take a moment
            to complete our short online Course Evaluation.<br />
            <a
              href="https://evaluations.bodytalksystem.com/default.aspx?id=#createEvaluation.LinkId#"
              >Click here</a
            ><br /><br />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvanceGraduation",
};
</script>

<style scoped>
.MainDiv {
  padding: 2rem;
  align-content: center;
  max-width: 1000px;
}
</style>
